import { render, staticRenderFns } from "./applyList.vue?vue&type=template&id=2d23a58c&scoped=true&"
import script from "./applyList.vue?vue&type=script&lang=js&"
export * from "./applyList.vue?vue&type=script&lang=js&"
import style0 from "./applyList.vue?vue&type=style&index=0&id=2d23a58c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23a58c",
  null
  
)

export default component.exports